import {
  Column,
  Columns,
  Heading,
  Stack,
  Text,
  Box,
} from 'braid-design-system';
import React from 'react';

import { TextLink } from 'src/components';

import * as style from './PromosItem.css';

interface PromosItemProp {
  title: string;
  subtext1: string;
  subtext2: string;
  linkTitle: string;
  href: string;
  imgSrc: string;
  isReverse: boolean;
  tracking: string;
}

const PromosItem = ({
  title,
  subtext1,
  subtext2,
  linkTitle,
  href,
  imgSrc,
  isReverse,
  tracking,
}: PromosItemProp) => (
  <Box
    className={style.responsive}
    width="full"
    marginTop={{ desktop: 'medium', mobile: 'large' }}
    paddingX={{ mobile: 'gutter', desktop: 'none' }}
  >
    <Columns
      collapseBelow="desktop"
      align="center"
      alignY="center"
      space={{ desktop: 'xxlarge', mobile: 'large' }}
      reverse={isReverse}
    >
      <Column width="1/2">
        <Box
          borderRadius="large"
          width="full"
          className={style.image}
          style={{
            backgroundImage: `url(${imgSrc})`,
          }}
        />
      </Column>
      <Column width="1/2">
        <Stack space="large">
          <Heading level="2">{title}</Heading>
          <Text size="large" component="p">
            {subtext1}
          </Text>
          <Text size="large">{subtext2}</Text>
          <Text size="large">
            <TextLink tracking={tracking} href={href}>
              {linkTitle}
            </TextLink>
          </Text>
        </Stack>
      </Column>
    </Columns>
  </Box>
);

export default PromosItem;
